import React from 'react';
import PropTypes from 'prop-types';
import * as immutable from 'immutable';
import Dialog from 'components/pure/utils/Dialog';
import Button from '@material-ui/core/Button';
import './TopicMergeConfirmationDialog.styl';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import {TextField} from 'material-ui';

/**
 * Dialog prompting the user to confirm or cancel topic merge.
 */
export default class TopicMergeConfirmationDialog extends React.PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    topicsSelectedForMerge: PropTypes.instanceOf(immutable.Iterable).isRequired,
  };

  state = {
    mergedName: '',
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && !prevProps.open) {
      this.setState({
        mergedName:
          this.props.topicsSelectedForMerge && this.props.topicsSelectedForMerge.first()
            ? this.props.topicsSelectedForMerge.first().word
            : '',
      });
    }
  }

  render() {
    const {onClose, onConfirm, open, topicsSelectedForMerge} = this.props;
    const {mergedName} = this.state;

    const title = `Merge ${topicsSelectedForMerge.size} Topics?`;
    return (
      <Dialog
        open={open}
        onRequestClose={onClose}
        title={title}
        modal
        autoScrollBodyContent={false}
        closeButton={false}
        contentClassName="topic-merge-confirmation-dialog-content"
        className="topic-merge-confirmation-dialog">
        <div>
          <div className="topic-merge-confirmation-dialog-preface">Clicking yes will...</div>
          <ul className="topic-merge-confirmation-dialog-consequences">
            <li>Copy all unique words into one topic.</li>
            <li>Reassociate all smart alerts with the resulting single topic.</li>
          </ul>

          <FieldContainer label={'Topic Name:'}>
            <TextField
              name={'Topic Name'}
              value={mergedName}
              onChange={e => this.setState({mergedName: e.target.value})}
            />
          </FieldContainer>
          <div className="topic-merge-confirmation-dialog-buttons">
            <Button variant="outlined" onClick={onClose} className="no-button ev-button">
              No - Do Not Merge
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => onConfirm(mergedName)}
              className="yes-button ev-button">
              Yes - Merge
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}
